import styled from 'styled-components';
import CoreButton from 'components/Buttons/CoreButton';
import { BUTTON_COLORS, COLORS } from 'constants/design';

export const StyledPrimaryButton = styled(CoreButton)`
  &.MuiButton-root {
    padding: ${props => (props.padding ? props.padding : '5px')};
    min-width: 104px;
    height: ${props => (props.height ? props.height : '46px')};
    background-color: ${props =>
      props.background ? props.background : BUTTON_COLORS.PRIMARY_GOLDEN};
    border: 1px solid
      ${props => (props.border ? props.border : BUTTON_COLORS.PRIMARY_GOLDEN)};
    border-radius: 4px;
    &:hover {
      background-color: ${props =>
        props.background
          ? props.background
          : BUTTON_COLORS.PRIMARY_HOVER_GOLDEN};
      border: 1px solid
        ${props =>
          props.border ? props.border : BUTTON_COLORS.PRIMARY_HOVER_GOLDEN};
    }
  }

  div.primary-button-title:first-letter {
    text-transform: capitalize;
  }
  .primary-button-title {
    text-transform: lowercase;
    font-size: 14px;
    letter-spacing: 0.01px;
    color: ${props => (props ? props.titlecolor : '#33e48')};
  }

  &.MuiButton-root.Mui-disabled {
    color: ${props => (props.titlecolor ? props.titlecolor : '#000')};
    opacity: 0.5;
  }
`;

export const StyledActionButton = styled(CoreButton)`
  &.MuiButton-root {
    padding: 5px;
    min-width: 125px;
    height: 36px;
    background-color: transparent;
    border-radius: 4px;
  }
  div.action-button-title:first-letter {
    text-transform: capitalize;
  }
  .action-button-title {
    text-transform: lowercase;
    font-size: 14px;
    letter-spacing: 0.01px;
    color: #384164;
  }
`;

export const StyledSecondaryButton = styled(CoreButton)`
  background-color: #fff;
  border: 1px solid ${props => (props.border ? props.border : COLORS.GREY)};
  border-radius: 4px;
  padding: 5px;
  min-width: 104px;
  height: 46px;

  div.secondary-button-title:first-letter {
    text-transform: capitalize;
  }

  .secondary-button-title {
    text-transform: lowercase;
    font-size: 14px;
    font-weight: medium;
    color: ${props => (props ? props.titlecolor : '#323e48')};
  }
`;

export const StyledRoundButton = styled(CoreButton)`
  &.MuiButton-root {
    padding: 4px;
    padding-left: 5px;
    min-width: 20px !important;
    height: 32px;
    background-color: ${props =>
      props.background ? props.background : BUTTON_COLORS.PRIMARY_GOLDEN};
    border-radius: 50px;
  }
`;
